<div class="bottom-navbar">
    <button type="button" (click)="navigateToHome()">
        <span class="icon" [ngClass]="{'active': activeUrl === 'dashboard'}">
            <img src="https://cdn.lokos.in/aajeevika/assets/img/home-{{activeUrl === 'dashboard' ? 'active' : 'inactive'}}.svg" alt="">
        </span>
        <span class="text-label">{{'home' | translate}}</span>
    </button>
    <button type="button" (click)="navigateToTasks()">
        <span class="icon" [ngClass]="{'active': activeUrl === 'tasks'}">
            <img src="https://cdn.lokos.in/aajeevika/assets/img/tasks-{{activeUrl === 'tasks' ? 'active' : 'inactive'}}.svg" alt="">
        </span>
        <span class="text-label">{{'tasks' | translate}}</span>
    </button>
    <button type="button" (click)="navigateToMembers()">
        <span class="icon" [ngClass]="{'active': activeUrl === 'members'}">
            <img src="https://cdn.lokos.in/aajeevika/assets/img/members-{{activeUrl === 'members' ? 'active' : 'inactive'}}.svg" alt="">
        </span>
        <span class="text-label">{{'members' | translate}}</span>
    </button>
    <!-- <button type="button" (click)="navigateToMapMembers()">
        <span class="icon" [ngClass]="{'active': activeUrl === 'mapMembers'}">
            <img src="https://cdn.lokos.in/aajeevika/assets/img/map-member-icon-{{activeUrl === 'mapMembers' ? 'active' : 'inactive'}}.svg" alt="">
        </span>
        <span class="text-label">{{'mapMembers' | translate}}</span>
    </button> -->
    <button type="button" (click)="navigateToPlanning()">
        <span class="icon" [ngClass]="{'active': activeUrl === 'planning'}">
            <img src="https://cdn.lokos.in//aajeevika-assets/images/planning-{{activeUrl === 'planning' ? 'active' : 'inactive'}}.svg" alt="">
        </span>
        <span class="text-label">{{'enterprisePlanning' | translate}}</span>
    </button>
</div>
